import { CreateTask, ID, Task, TaskActionType } from '@griply/types';
import { taskGoalIds, taskLifeAreaIds } from '@griply/utils';

export type GoalCreateUpdate = {
  taskIds: ID[];
  sectionId: ID | null;
  hasGoalTimeslot: boolean;
};

export type LifeAreaCreateUpdate = { taskIds: ID[]; sectionId: ID };

export const aggregateGoalUpdates = (
  tasks: CreateTask[],
  createdTasks: Task[],
) => {
  const goalUpdates = new Map<
    ID,
    { taskIds: ID[]; sectionId: ID | null; hasGoalTimeslot: boolean }
  >();

  for (const [index, createdTask] of createdTasks.entries()) {
    const sectionId = tasks[index].sectionId;

    // The new task belongs to every goal it links to, so each one is updated.
    taskGoalIds(createdTask).forEach((goalId) => {
      const existing = goalUpdates.get(goalId);

      if (existing) {
        existing.taskIds.push(createdTask.id);
        if (!existing.hasGoalTimeslot) {
          existing.hasGoalTimeslot =
            createdTask.action?.type === TaskActionType.GoalTimeslot;
        }
        return;
      }

      goalUpdates.set(goalId, {
        taskIds: [createdTask.id],
        sectionId,
        hasGoalTimeslot:
          createdTask.action?.type === TaskActionType.GoalTimeslot,
      });
    });
  }

  return goalUpdates;
};

export const aggregateLifeAreaUpdates = (
  tasks: CreateTask[],
  createdTasks: Task[],
) => {
  const lifeAreaUpdates = new Map<ID, { taskIds: ID[]; sectionId: ID }>();

  for (const [index, createdTask] of createdTasks.entries()) {
    const sectionId = tasks[index].sectionId;
    if (!sectionId) {
      continue;
    }

    taskLifeAreaIds(createdTask).forEach((lifeAreaId) => {
      const existing = lifeAreaUpdates.get(lifeAreaId);
      if (existing) {
        existing.taskIds.push(createdTask.id);
        return;
      }

      lifeAreaUpdates.set(lifeAreaId, {
        taskIds: [createdTask.id],
        sectionId,
      });
    });
  }

  return lifeAreaUpdates;
};
